import { hrControls } from '$lib/PersistedState.svelte';

let averageWindow: number[] = [];
let heatingRateWindow: number[] = [];

export const resetHeatingRate = () => {
  averageWindow = [];
  heatingRateWindow = [];
};

export const calculateHeatingRate = (currentTemperature: number) => {
  /**
   * First, deal with the sliding window of temperature which we use to create average temps, hence
   * smoothing out the numbers a bit. This smoothing will be used to calculate the heating rate.
   */
  averageWindow.push(currentTemperature);
  if (averageWindow.length > hrControls.avgWindowLength) {
    averageWindow.shift();
  }

  /**
   * Get the average of the temperatures in our sliding window from above.  This value is
   * placed on the heating rate array and used to calculate the actual heating rate value which the
   * user will see.
   *
   * Note that the numbers in this array are the average values from the array above.
   */
  const averageTemp = averageWindow.reduce((acc, avg) => acc + avg) / averageWindow.length;

  heatingRateWindow.push(averageTemp);
  if (heatingRateWindow.length > hrControls.deltaSpan) {
    heatingRateWindow.shift();
  }

  /**
   * Determine the index for calculating the rate of change - necessary when we are starting up and
   * the array is not the right size.
   */
  let nextMinuendIndex = hrControls.deltaSpan - 1;
  if (heatingRateWindow.length <= hrControls.deltaSpan) {
    nextMinuendIndex = heatingRateWindow.length - 1;
  }

  // Do a bit of math to get our heating rate in degrees per minute
  let divisor = heatingRateWindow.length - 1;
  if (divisor === 0) divisor = 1;
  const hrMultiple = 60.0 / divisor;
  const heatingRate = (heatingRateWindow[nextMinuendIndex] - heatingRateWindow[0]) * hrMultiple;

  return heatingRate;
};
